exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".alert {\n  border: 1px solid #ebebeb;\n  width: 100%;\n  margin: 0 auto;\n  border-radius: 0px;\n  padding: 0px; }\n\n.alert .alert-header {\n  padding: 5px 10px;\n  background: #0f71d3; }\n\n.alert .alert-header h2 {\n  line-height: normal;\n  font-size: 16px;\n  color: #fff;\n  float: left; }\n\n.alert .alert-header .close {\n  color: #fff;\n  float: right;\n  opacity: 10;\n  font-size: 13px;\n  font-weight: 300;\n  padding-top: 4px; }\n\n.alert .alert-content {\n  padding: 10px;\n  padding-top: 30px; }\n\n.alert .alert-content p {\n  color: #333;\n  line-height: 22px; }\n\n.alert .alert-content input {\n  width: 90%; }\n\n.alert .alert-footer {\n  padding: 10px;\n  text-align: right; }\n\n.btn.medium {\n  padding: 0px 15px;\n  height: 30px;\n  line-height: 30px;\n  font-size: 14px; }\n\n.btn.red {\n  background: #f33923;\n  color: #fff; }\n\n.btn.green {\n  background: #4aa23c;\n  color: #fff; }\n\n.alert .alert-header h2 {\n  line-height: normal;\n  font-size: 16px;\n  color: #fff;\n  float: left;\n  width: auto; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/shared/components/prompt-modal/prompt-modal.component.scss
// module id = 1469
// module chunks = 18